import { modals } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

export const useOpenInviteTypeModal = () => {
  const { t } = useTranslation();

  return (
    assetId: string,
    onOpenAddMemberModal: () => void,
    onOpenInviteByEmailModal: () => void
  ) => {
    modals.openContextModal({
      modal: 'inviteType',
      title: t('admin.inviteModal.title', 'Ajouter un membre'),
      innerProps: { assetId, onOpenAddMemberModal, onOpenInviteByEmailModal },
      size: 'md',
    });
  };
};
